export const FETCH_EXTERNAL_GROUP_RELATIONS         = 'FETCH_EXTERNAL_GROUP_RELATIONS';
export const FETCH_EXTERNAL_GROUP_RELATIONS_SUCCESS = 'FETCH_EXTERNAL_GROUP_RELATIONS_SUCCESS';
export const FETCH_EXTERNAL_GROUP_RELATIONS_FAILURE = 'FETCH_EXTERNAL_GROUP_RELATIONS_FAILURE';

export const DELETE_EXTERNAL_GROUP_RELATION         = 'DELETE_EXTERNAL_GROUP_RELATION';
export const DELETE_EXTERNAL_GROUP_RELATION_SUCCESS = 'DELETE_EXTERNAL_GROUP_RELATION_SUCCESS';
export const DELETE_EXTERNAL_GROUP_RELATION_FAILURE = 'DELETE_EXTERNAL_GROUP_RELATION_FAILURE';

export const UPDATE_EXTERNAL_GROUP_RELATION         = 'UPDATE_EXTERNAL_GROUP_RELATION';
export const UPDATE_EXTERNAL_GROUP_RELATION_SUCCESS = 'UPDATE_EXTERNAL_GROUP_RELATION_SUCCESS';
export const UPDATE_EXTERNAL_GROUP_RELATION_FAILURE = 'UPDATE_EXTERNAL_GROUP_RELATION_FAILURE';

export const CREATE_EXTERNAL_GROUP_RELATION         = 'CREATE_EXTERNAL_GROUP_RELATION';
export const CREATE_EXTERNAL_GROUP_RELATION_SUCCESS = 'CREATE_EXTERNAL_GROUP_RELATION_SUCCESS';
export const CREATE_EXTERNAL_GROUP_RELATION_FAILURE = 'CREATE_EXTERNAL_GROUP_RELATION_FAILURE';

export const FETCH_GROUPS                           = 'FETCH_GROUPS';
export const FETCH_GROUPS_SUCCESS                   = 'FETCH_GROUPS_SUCCESS';
export const FETCH_GROUPS_FAILURE                   = 'FETCH_GROUPS_FAILURE';

export const IMPORT_EXTERNAL_GROUP_RELATION         = 'IMPORT_EXTERNAL_GROUP_RELATION';
export const IMPORT_EXTERNAL_GROUP_RELATION_SUCCESS = 'IMPORT_EXTERNAL_GROUP_RELATION_SUCCESS';
export const IMPORT_EXTERNAL_GROUP_RELATION_FAILURE = 'IMPORT_EXTERNAL_GROUP_RELATION_FAILURE';

export function fetchExternalGroupRelationsAction(data) {
  return {
    type:    FETCH_EXTERNAL_GROUP_RELATIONS,
    payload: data
  };
}

export function fetchExternalGroupRelationsSuccess(response) {
  return {
    type:    FETCH_EXTERNAL_GROUP_RELATIONS_SUCCESS,
    payload: response
  };
}

export function fetchExternalGroupRelationsFailure(errors) {
  return {
    type:    FETCH_EXTERNAL_GROUP_RELATIONS_FAILURE,
    payload: errors
  };
}

export function deleteExternalGroupRelationAction(data) {
  return {
    type:    DELETE_EXTERNAL_GROUP_RELATION,
    payload: data
  };
}

export function deleteExternalGroupRelationSuccess(response) {
  return {
    type:    DELETE_EXTERNAL_GROUP_RELATION_SUCCESS,
    payload: response
  };
}

export function deleteExternalGroupRelationFailure(errors) {
  return {
    type:    DELETE_EXTERNAL_GROUP_RELATION_FAILURE,
    payload: errors
  };
}

export function updateExternalGroupRelationAction(data) {
  return {
    type:    UPDATE_EXTERNAL_GROUP_RELATION,
    payload: data
  };
}

export function updateExternalGroupRelationSuccess(response) {
  return {
    type:    UPDATE_EXTERNAL_GROUP_RELATION_SUCCESS,
    payload: response
  };
}

export function updateExternalGroupRelationFailure(errors) {
  return {
    type:    UPDATE_EXTERNAL_GROUP_RELATION_FAILURE,
    payload: errors
  };
}

export function createExternalGroupRelationAction(data) {
  return {
    type:    CREATE_EXTERNAL_GROUP_RELATION,
    payload: data
  };
}

export function createExternalGroupRelationSuccess(response) {
  return {
    type:    CREATE_EXTERNAL_GROUP_RELATION_SUCCESS,
    payload: response
  };
}

export function createExternalGroupRelationFailure(errors) {
  return {
    type:    CREATE_EXTERNAL_GROUP_RELATION_FAILURE,
    payload: errors
  };
}

export function fetchGroupsAction(data) {
  return {
    type:    FETCH_GROUPS,
    payload: data
  };
}

export function fetchGroupsSuccess(response) {
  return {
    type:    FETCH_GROUPS_SUCCESS,
    payload: response
  };
}

export function fetchGroupsFailure(errors) {
  return {
    type:    FETCH_GROUPS_FAILURE,
    payload: errors
  };
}

export function importExternalGroupRelationAction(data) {
  return {
    type:    IMPORT_EXTERNAL_GROUP_RELATION,
    payload: data
  }
}

export function importExternalGroupRelationSuccess(response) {
  return {
    type:    IMPORT_EXTERNAL_GROUP_RELATION_SUCCESS,
    payload: response
  }
}

export function importExternalGroupRelationFailure(errors) {
  return {
    type:    IMPORT_EXTERNAL_GROUP_RELATION_FAILURE,
    payload: errors
  }
}
